import React from 'react';

const SvgPlus = props => (
  <svg width={13} height={13} {...props}>
    <path
      d="M6 6V.5a.5.5 0 0 1 1 0V6h5.5a.5.5 0 0 1 0 1H7v5.5a.5.5 0 0 1-1 0V7H.5a.5.5 0 0 1 0-1H6z"
      fill="#FFF"
      fillRule="nonzero"
    />
  </svg>
);

export default SvgPlus;
